<ui-section class="ui-gap section">

  <ui-sidebar class="ez-lib-sidebar"
    [items]="sidebarConfig"
    [showDividers]="false"
    sidebarWidth="200px"
    [hideCollapser]="false"
    [matIcon]="'play_arrow'"
    [orderBy]="'order'"

    defaultRoute="basePath"
    >
  </ui-sidebar>

  @if(selectedClassEntry())
  {
    <ui-block width="fill" class="calc-full-height">
      <ui-tab-group class="h-full showcase-tabs" #tabs
        [tabConfig]="tabConfig"
        [(tabIndex)]="staticTabIndex"
      ></ui-tab-group>
    </ui-block>
  }

  @if(docPath())
  {
    <!-- <ui-section class="overflow-y-auto"> -->
      <ui-block class="overflow-x-hidden">
        <markdown [src]="docPath()"></markdown>
      </ui-block>
    <!-- </ui-section> -->
  }

</ui-section>
